import { Box } from '@material-ui/core';
import { Money } from '@nemuru-eng/js-api-client';
import { Insurance } from '@nemuru-eng/js-api-client/slim';
import React, { useState } from 'react';

import { InsurancePopover } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ConditionsAndProgress/Conditions/components/InsurancePopover';
import { LoanInsuranceMap } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/maps/loanInsurance.map';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { InsuranceProviderLogo } from '@/components/shared/components/Logo/InsuranceProviderLogo/InsuranceProviderLogo';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface InsuranceScoreCardProps {
  principal: Money;
  term: number;
  insurance: Insurance | null;
}

export const InsuranceScoreCard = ({ insurance, principal, term }: InsuranceScoreCardProps) => {
  const { getTextIdTranslation: t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const hasPricingDetails = LoanInsuranceMap.hasPricingDetails(insurance);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        minWidth={80}
        maxWidth={140}
        style={{ cursor: hasPricingDetails ? 'pointer' : 'default' }}
        onClick={
          hasPricingDetails
            ? (event: React.MouseEvent<HTMLDivElement>) => setAnchorEl(event.currentTarget)
            : undefined
        }
      >
        <Font variant="body2" color="textSecondary" display="block">
          <Text tId="INSURANCE" />
        </Font>
        <FlexRow alignItems={'center'} gridGap={8}>
          {insurance ? (
            <>
              <Box flexShrink={0}>
                <Font variant="subtitle1">{t(`INSURANCE_TYPE_${insurance.type}`)}</Font>
              </Box>
              {insurance.provider && <InsuranceProviderLogo size={16} insuranceProvider={insurance.provider} />}
            </>
          ) : (
            <Box flexShrink={0}>
              <Font variant="subtitle1">{t('INSURANCE_TYPE_NONE')}</Font>
            </Box>
          )}
        </FlexRow>
      </Box>
      {hasPricingDetails && (
        <InsurancePopover
          anchorEl={anchorEl}
          onClose={handleClose}
          insurance={insurance}
          principal={principal}
          term={term}
        />
      )}
    </>
  );
};
